import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Events } from 'src/app/shared/constants/events.constant';
import { LoggingService } from './logging.service';

@Injectable({
  providedIn: 'root',
})
export class EventService {
  public events = new Subject<Events>();

  constructor() {}

  public dispatch(event: Events) {
    this.events.next(event);
  }
}
